import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import i18n from 'i18n';
import ApplicationState from 'store/interfaces';
import { connect } from 'react-redux';
import { isClientOperator } from 'utils/role';
import { RolesEnum } from 'modules/authenticate/interfaces';
import { ClientFields } from 'modules/clients/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface ClientSummaryProps {
  client?: ClientFields | null;
  role?: RolesEnum;
}

const ClientSummary = ({ client, role }: ClientSummaryProps) => {
  const classes = useStyles();

  return (
    <Grid container data-testid={'autosky-clientsummary'}>
      <Grid container className={classes.summaryData}>
        <Typography className={classes.title}>
          {i18n.t('CLIENT_KEY')}
          {':'}
        </Typography>
        <Typography className={classes.value}>{client?.name}</Typography>
      </Grid>
      <Grid container className={classes.summaryData}>
        <Typography className={classes.title}>
          {i18n.t('ENVIRONMENT_KEY')}
          {':'}
        </Typography>
        <Typography className={classes.value}>
          {client?.environment?.name}
        </Typography>
      </Grid>
      {!isClientOperator(role) && (
        <Grid container className={classes.summaryData}>
          <Typography className={classes.title}>
            {i18n.t('LICENSES_KEY')}
            {':'}
          </Typography>
          <Typography className={classes.value}>
            {client?.licenses?.license_group?.license_limit ||
              client?.licenses?.client_license?.license_limit ||
              '-'}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

const mapStateToProps = ({ authenticate: { data } }: ApplicationState) => ({
  role: data?.role,
});

export default connect(mapStateToProps, {})(ClientSummary);
